import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  constructor(
    private http: HttpClient,
    private config: ConfigService
  ) { }

  getFranchiseAndCouponFlags(): Observable<any> {
    return this.http.get(this.config.json.apiEndpoint + 'common/getCouponAndFranchiseEnabledOrDisabled');
  }

  setFlagsInLocalStorage(franchiseEnable, distributorEnable, couponEnable, client, thirdPartyEnabled, clientId, operatorId, isPlan) {
    localStorage.setItem('franchiseEnable', franchiseEnable)
    localStorage.setItem('distributorEnable', distributorEnable)
    localStorage.setItem('couponEnable', couponEnable)
    localStorage.setItem('client', client)
    localStorage.setItem('thirdPartyEnabled', thirdPartyEnabled)
    localStorage.setItem('clientId', clientId)
    localStorage.setItem('operatorId', operatorId)
    localStorage.setItem('isPlan', isPlan)

  }

  getFranchiseEnableFlag() {
    return localStorage.getItem('franchiseEnable')
  }
  getDistributorEnableFlag() {
    return localStorage.getItem('distributorEnable')
  }

  getCouponEnableFlag() {
    return localStorage.getItem('couponEnable')
  }

  getClientInfo() {
    return localStorage.getItem('client')
  }

  getThirdPartyEnabled() {
    return localStorage.getItem('thirdPartyEnabled')
  }

  getClientId() {
    return localStorage.getItem('clientId')
  }

  getOperatorId() {
    return localStorage.getItem('operatorId')
  }
  getisPlan() {
    return localStorage.getItem('isPlan')
  }
}
